import { extendTheme, theme as chakraTheme, StyleFunctionProps } from '@chakra-ui/react';
import { headingTheme } from './components/heading';

const theme = extendTheme({
    fonts: {
        heading: `'Poppins', Arial, sans-serif`,
        body: `'Poppins', Arial, sans-serif`,
    },
    colors: {
        primary: '#1AAC7A',
        dark: {
            1: '#EEEEEE',
            2: '#C8C8C8',
            3: '#818181',
            4: '#515151',
            5: '#171717',
        },
        white: '#FFFFFF',
        red: {
            50: '#FDE8E7',
            100: '#FAC7C3',
            200: '#F6A19B',
            300: '#F27B73',
            400: '#F05F55',
            500: '#ED4337',
            600: '#EB3D31',
            700: '#E8342A',
            800: '#E52C23',
            900: '#E01E16',
        },
        yellow: {
            50: '#FFFCE7',
            100: '#FEF8C2',
            200: '#FDF39A',
            300: '#FCEE71',
            400: '#FCEB52',
            500: '#FBE734',
            600: '#FAE42F',
            700: '#FAE027',
            800: '#F9DD21',
            900: '#F8D715',
        },
        orange: {
            25: '#FFF9EB',
            50: '#FFF6E0',
            100: '#FFE9B3',
            200: '#FFDA80',
            300: '#FFCB4D',
            400: '#FFBF26',
            500: '#FFB400',
            600: '#FFAD00',
            700: '#FFA400',
            800: '#FF9C00',
            900: '#FF8C00',
        },
        green: {
            25: '#F4FAF3',
            50: '#EEF7ED',
            100: '#D5EBD2',
            200: '#B9DDB4',
            300: '#9CCF96',
            400: '#87C580',
            500: '#72BB69',
            600: '#6AB561',
            700: '#5FAC56',
            800: '#55A44C',
            900: '#42963B',
        },
        brand: {
            50: '#FFEAEA',
            100: '#FFC9C9',
            200: '#FFA6A6',
            300: '#FF8282',
            400: '#FF6767',
            500: '#FF4C4C',
            600: '#FF4545',
            700: '#FF3C3C',
            800: '#FF3333',
            900: '#FF2424',
        },
        secondary: {
            25: '#EBF1F8',
            50: '#E0EAF4',
            100: '#B3CBE3',
            200: '#80A8D0',
            300: '#4D85BD',
            400: '#266AAE',
            500: '#0050A0',
            600: '#004998',
            700: '#00408E',
            800: '#003784',
            900: '#002773',
        },
        gray: {
            50: '#FAFAFA',
            100: '#F5F5F5',
            200: '#EEEEEE',
            300: '#E0E0E0',
            400: '#BDBDBD',
            500: '#9E9E9E',
            600: '#757575',
            700: '#616161',
            800: '#424242',
            900: '#212121',
        },
        success: chakraTheme.colors.green,
        warning: chakraTheme.colors.orange,
        promo: chakraTheme.colors.yellow,
        danger: chakraTheme.colors.red,

        logoPrimary: '#FF3939',
    },
    components: { Heading: { headingTheme } },
});
export default theme;
